import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { er } from '@fullcalendar/core/internal-common';
import { Observable, Subscription, tap } from 'rxjs';
import { environment } from 'src/environments/environment';

const UPDATE_TYPE_REWARD_API_URL =
  '/api/v1/quiz/builder/type-recompense/updatetype-recompense/';

const DELETE_TYPE_REWARD_API_URL =
  '/api/v1/quiz/builder/type-recompense/deletetype-recompense/';

const GET_TYPE_REWARD_API_URL =
  '/api/v1/quiz/builder/type-recompense/gettype-recompenses?pagination=false';

const ADD_TYPE_REWARD_API_URL = '/api/v1/quiz/builder/type-recompense/addtype-recompense';

const BASE_URL = environment.BASE_URL;

@Injectable({
  providedIn: 'root',
})
export class TypeRecompenseService {
  constructor(private http: HttpClient) {}

  getAllRewardType(): Observable<any[]> {
    return this.http.get<any>(`${BASE_URL}${GET_TYPE_REWARD_API_URL}`);
  }

  createRewardType(rewardTpeData: any): Observable<any> {
    const data = {
      libelle: rewardTpeData
    };

    return this.http
      .post<any>(`${BASE_URL}${ADD_TYPE_REWARD_API_URL}?libelle=${rewardTpeData}`, {})
      .pipe(
        tap({
          next: (data) => {
            console.log('type reward cree avec succes :', data);
          },
          error: (err) => {
            console.log('Erreur survenue ', err);
          }
        })
      );
  }


  updateRewardType(rewardTpeData: any, id: number) {
    const data = {};

    return this.http
      .put<any>(`${BASE_URL}${UPDATE_TYPE_REWARD_API_URL}${id}?libelle=${rewardTpeData}`, data)
      .subscribe({
        next: (data) => {
          console.log('type reward cree avec succes :', data);
        },
        error(err) {
          console.log('Erreur survenue ', err);
        },
      });
  }

  deleteRewardType(id: number): Observable<any> {
    return this.http
      .delete<any>(`${BASE_URL}${DELETE_TYPE_REWARD_API_URL}${id}`)
      // .subscribe({
      //   next: (data) => console.log('donnes supprimer :', data),
      // });
  }
}
